import React, {memo, useState} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from 'common/names';
import FileManager from './FileManager';
import Checkbox from 'components/inputs/Checkbox';
import {useTranslation} from 'react-i18next';

export type FileManagerMergeDialogResult = {filePath: string; suspend?: boolean};
export type FileManagerMergeDialogProps = {
   initialPath?: string;
   open: boolean;
   title?: string;
   filesOfType?: string[];
   directoriesOnly?: boolean;
   // onConfirm: (data: IData) => void;
   // onClose: () => void;
   suspendCheckbox?: boolean;
};

export type FileManagerMergeDialogData = Omit<FileManagerMergeDialogProps, 'onClose' | 'onConfirm'>;
type Props = {
   data: FileManagerMergeDialogData;
   onClose: (path?: FileManagerMergeDialogResult) => void;
};

const FileManagerMergeDialog = memo(
   ({
      data: {
         initialPath = '',
         open = true,
         title = DialogTypes.FileManager.dialogName,
         filesOfType,
         suspendCheckbox,
         directoriesOnly,
      },
      onClose,
   }: Props) => {
      const {t} = useTranslation();
      const [suspend, setSuspend] = useState(true);

      const handleSelect = (filePath: string) => {
         onClose({filePath, suspend});
      };

      return (
         <DialogComponent open={open} maxWidth="md" header={title} close={onClose}>
            {open && (
               <FileManager
                  initialPath={initialPath}
                  directoriesOnly={directoriesOnly}
                  filesOfType={filesOfType}
                  onSelect={handleSelect}
                  onCancel={onClose}
                  formFooter={
                     suspendCheckbox ? (
                        <Checkbox
                           name="suspend"
                           checked={suspend}
                           label={t('Set Merged Transaction(s) to Suspended')}
                           onChange={(ev, checked) => setSuspend(checked)}
                        />
                     ) : undefined
                  }
               />
            )}
         </DialogComponent>
      );
   }
);

export default FileManagerMergeDialog;
